import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from '../app/shared/material.module';
import { BearerTokenInterceptor } from './core/security/bearer-token.interceptor';
import { LogoutUnauthorizedInterceptor } from './core/security/logout-unauthorized.interceptor';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaskModule } from 'ngx-mask';
import { HttpLoggingInterceptor } from './core/logging/http-logging.interceptor';
import { LoaderInterceptorService } from './shared/components/loader/loader.interceptor';
import { RxReactiveFormsModule } from "@rxweb/reactive-form-validators";
import { IdleTokenTimeoutModule } from './shared/idle-token-timeout/idle-token-timeout.module';
import { CloseableSnackbarComponent } from './shared/components/closeable-snackbar';
import { AppRoutingModule, routes } from './app-routing.module';
import { AuthenticationService } from './core/services/authentication.service';
import { AuthGuard, SkipIfAuthenticatedGuard } from './core/security';
import { DevAuthGuard } from './core/security/dev-auth.guard';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AppComponent, CloseableSnackbarComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    IdleTokenTimeoutModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot({}),
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    HttpClientModule,
    RxReactiveFormsModule,
    RouterModule
  ],
  providers: [
    AuthenticationService,
    AuthGuard,
    SkipIfAuthenticatedGuard,
    DevAuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BearerTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogoutUnauthorizedInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoggingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
